module.exports = __webpack_public_path__ + "static/img/2.2b06423.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/sp/2.png
// module id = kCHm
// module chunks = 0